<template>
  <v-toolbar
    app
    color="semBl"
    dark
  >
    <v-avatar tile>
      <v-img :src="logoIK" alt="iK_logo" height="90%" contain @click="infoK()"/>
    </v-avatar>
    <!-- <v-avatar tile> -->
      <!-- <v-img :src="logoSEM" alt="SEM_logo" height="100%" contain /> -->
    <!-- </v-avatar> -->

      <v-img :src="logoSEM" alt="SEM_logo" height="100%" contain />

    <v-toolbar-title></v-toolbar-title>

    <v-spacer/>

    <v-btn
      color="semAz"
      class="white--text"
      @click="changeView()"
    >
      {{ btntxt }}
      <v-icon right dark>{{ btnicn }}</v-icon>
    </v-btn>

    <v-menu bottom left>
      <template v-slot:activator="{ on }">
        <v-btn
          color="semVr"
          class="white--text"
          dark
          icon
          v-on="on"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-tile @click="dialogIntro = true">
          <v-list-tile-title>Introducción</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="dialogIni = true">
          <v-list-tile-title>Iniciativa</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="dialogCopyR = true">
          <v-list-tile-title>Acerca de</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-dialog
      v-model="dialogIntro"
      max-width="67vw"
      transition="dialog-bottom-transition"
    >
      <v-card
        flat
        tile
      >
        <v-toolbar dark color="semAz">
          <v-btn icon color="semRj" @click="dialogIntro = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Introducción</v-toolbar-title>
        </v-toolbar>

        <v-window v-model="onboarding">
          <v-window-item>
            <v-card color="transparent">
              <v-card-text>
                <v-img
                  :src="intro1"
                  contain
                  :key="imgKey"
                ></v-img>
              </v-card-text>
            </v-card>
          </v-window-item>

          <v-window-item>
            <v-card color="transparent">
              <v-card-text>
                <v-img
                  :src="intro2"
                  contain
                  :key="imgKey"
                ></v-img>
              </v-card-text>
            </v-card>
          </v-window-item>

          <v-window-item>
            <v-card color="transparent">
              <v-card-text>
                <v-img
                  :src="intro3"
                  contain
                  :key="imgKey"
                ></v-img>
              </v-card-text>
            </v-card>
          </v-window-item>

          <v-window-item>
            <v-card color="transparent">
              <v-card-text>
                <v-img
                  :src="intro4"
                  contain
                  :key="imgKey"
                ></v-img>
              </v-card-text>
            </v-card>
          </v-window-item>
        </v-window>

        <v-card-actions class="justify-space-between">
          <v-btn
            flat
            @click="prev"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-item-group
            v-model="onboarding"
            class="text-xs-center"
            mandatory
          >
            <v-item
              v-for="n in 4"
              :key="`btn-${n}`"
            >
              <v-btn
                slot-scope="{ active, toggle }"
                :input-value="active"
                icon
                @click="toggle"
              >
                <v-icon>mdi-record</v-icon>
              </v-btn>
            </v-item>
          </v-item-group>
          <v-btn
            flat
            @click="next"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogIni"
      max-width="67vw"
      transition="dialog-bottom-transition"
    >
      <v-card
        flat
        tile
      >
        <v-toolbar dark color="semAz">
          <v-btn icon color="semRj" @click="dialogIni = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Iniciativa</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title class="title">
              Acompañamiento Situado y diferencial
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
              La  ejecución de la iniciativa MCEE  tuvo que plantearse acorde a las dinámicas institucionales que hacen parte de un contexto con condiciones únicas y especificidades que dan cuenta de problemáticas sociales inscritas en un territorio, que conjugan diversos elementos y permean los procesos desarrollados a nivel institucional, y de manera especial a los estudiantes y demás actores educativo, por lo que al ejecutar dichos proyectos hubo que leer, plantear y acomodar a  las dinámicas institucionales, territoriales y las condiciones propias en cada institución e incluso cada sede. <br>

              Es entonces como el acompañamiento situado y diferencial muestra que cada Institución es única, a pesar que la estructural;  posee procesos diferenciados. Por ende, para el desarrollo de está forma de acompañamiento fue necesario partir de una caracterización de los colegios, para así conocer lo existente en cada aspecto: lo artístico, deportivo, tecnológico, los Proyectos transversales pedagógicos, los procesos con las familias, la autoevaluación institucional, la actualización del PMI, entre otros.
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogCopyR"
      max-width="67vw"
      transition="dialog-bottom-transition"
    >
      <v-card
        flat
        tile
      >
        <v-toolbar dark color="semAz">
          <v-btn icon color="semRj" @click="dialogCopyR = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Acerca de esta Aplicación</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          Desarrolado por Infométrika S.A.S.
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-toolbar>
</template>

<script>
export default {
  name: 'Toolbar',

  components: {},

  data: function() {
    return {
      logoIK: require('../assets/logoIK.svg'),
      logoSEM: require('../assets/SEMCali.png'),
      intro1: require('./../assets/intro/intro1.svg'),
      intro2: require('./../assets/intro/intro2.svg'),
      intro3: require('./../assets/intro/intro3.svg'),
      intro4: require('./../assets/intro/intro4.svg'),

      dialogIntro: false,
      dialogIni: false,
      dialogCopyR: false,
      onboarding: 0,
      imgKey: 0
    }
  },
  watch: {
    dialogIntro: function () {
      this.imgKey += 1
      this.onboarding = 0
    }
  },

  computed: {
    view: {
      get () {
        return this.$store.state.view
      },
      set (val) {
        this.$store.commit('toggle_view', val)
      }
    },
    btntxt: function () {
      return this.view ? 'Cambiar a Informe Proyectos' : 'Cambiar a Informe IEO'
    },
    btnicn: function () {
      return this.view ? 'mdi-book-open-page-variant' : 'mdi-school'
    }
  },

  methods: {
    changeView () {
      this.view = !this.view
    },
    next () {
      this.onboarding = this.onboarding + 1 === 4
        ? 0
        : this.onboarding + 1
    },
    prev () {
      this.onboarding = this.onboarding - 1 < 0
        ? 4 - 1
        : this.onboarding - 1
    },
    infoK () {
      window.open("https://web.infometrika.com/", "_blank")
    }
  }
};
</script>
